import { render, staticRenderFns } from "./SkindexPage.vue?vue&type=template&id=9fee32f2&scoped=true&"
import script from "./SkindexPage.vue?vue&type=script&lang=js&"
export * from "./SkindexPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fee32f2",
  null
  
)

export default component.exports